module.exports = __webpack_public_path__ + "static/media/imageDIS.bf81b2d1.webp";